
import { gsap } from 'gsap';
import { debounce as _debounce } from 'underscore';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el   : false,
        	main  : null,

       };

        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'escr-menu-rollover';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;
        this.$win           =   $(window);
		

        this.init();
    }

    init(){
        this.cache();
    	this.addEvents( true );
	}

    cache(){
        let $el;
        this.imgs = [];
        this.$el.find( '.img-switch' ).each((i,el)=>{
            $el = $(el);
            this.imgs[ $el.attr('data-href') ] = $el;
        });
    }

    addEvents( b ){
        let $m = $('#menu-full-desktop');
        if( b ){
            $m.find( 'a' ).on( 'mouseenter', (e) => this.show(true,e) );
            $m.find( 'a' ).on( 'mouseleave', (e) => this.show(false,e) );
        }
        else{
            $m.find( 'a' ).off( 'mouseenter', (e) => this.show(true,e) );
            $m.find( 'a' ).off( 'mouseleave', (e) => this.show(false,e) );
        }
        this.debounceResize(b);
    }

    show(b, e){
        let $a = $(e.currentTarget), url = $a.attr('href'), $img;

        $img = this.imgs[ url ];
        if ( !$img ){
            return;
        }


        this.$img   = $img;

        if ( b ){
            $(document).on( 'mousemove', (e)=>this.onMouseMove(e) );

            gsap.to($img,{opacity:0.8,duration:0});
        }
        else{
            gsap.to($img,{opacity:0,duration:0});

            $(document).off( 'mousemove', (e)=>this.onMouseMove(e) );

            this.$img = false;
        }
    }

    onMouseMove(e){

        let $target = $(e.target), y, x;

        if ( this.$img ){

            y = e.clientY - $('#menu-full-desktop').offset().top - parseInt( $('#menu-full-desktop').css('padding-top') ) - this.$img.height() - 60;
            x = e.clientX + 30;

            gsap.to( this.$img, { x : x , y: y } );

           // gspa.to()
        


        }
    }

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 117 );
            this.$win.on( 'resize', this._debResize );
            this.onResize();
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    onResize(){
        let $wrap = this.$el.parent( '.scroll-panel' ).find( '.wrap' );

        gsap.set( this.$el, {top:$wrap.offset().top - $('#menu-panel').offset().top, left: $wrap.offset().left  } );
    }
    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
        this.addEvents( false );
    }

}